import { StaffingView, useStaffing } from "@/context/StaffingContext";
import { ColumnDef, DataTable, ServerSideOptions } from "../../common/DataTable";
import { Posting } from "@/types/staffing/posting";

export interface IPostingsSheetProps {
    view: StaffingView;
    columns: ColumnDef<Posting>[];
    serverSide?: Omit<ServerSideOptions, 'total'>;
    rowClassName?: (row: Posting) => string | undefined;
}

const PostingsSheet = (props: IPostingsSheetProps) => {
    const { postings, loading, totals, errors } = useStaffing();

    return (
        <DataTable
            data={postings[props.view]}
            columns={props.columns}
            loading={loading[props.view]}
            error={errors[props.view] ?? undefined}
            serverSide={props.serverSide ? { ...props.serverSide, total: totals[props.view] } : undefined}
            rowClassName={props.rowClassName}
        />
    );
};

export default PostingsSheet;
